import { FC } from 'react';
interface IProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
const ArrowIcon: FC<IProps> = ({ color = '#F5F7F6', ...props }) => {
  return (
    <svg
      width={14}
      height={10}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 4.35a.65.65 0 100 1.3v-1.3zm12.46 1.11a.65.65 0 000-.92L9.323.404a.65.65 0 10-.92.919L12.082 5 8.404 8.677a.65.65 0 00.92.92L13.46 5.46zM1 5.65h12v-1.3H1v1.3z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowIcon;
